import { FIRST_PARTY_SOURCE_ENUM } from '../../pages/first_party/first_party_constants';

// Helper constants for DMP segment detection
const DMP_SEGMENT_CREATION_DAYS = 3;
const DAYS_IN_MS = 24 * 60 * 60 * 1000;

// Helper function to detect if segment is DMP and created in last 3 days
export const isDmpRecentSegment = (segment) => {
  if (!segment || segment.first_party_source_id !== FIRST_PARTY_SOURCE_ENUM.DMP) return false;
  const createdAt = new Date(segment.created_at);
  const now = new Date();
  const diffMs = now.getTime() - createdAt.getTime();
  const diffDays = diffMs / DAYS_IN_MS;
  return diffDays <= DMP_SEGMENT_CREATION_DAYS;
};
